export type ImageData = {
  id: number;
  path: string;
  alt_tag: string;
  created_at: string;
  updated_at: string;
};

export default class Image {
  public id: number;
  public path: string;
  public altTag: string;
  public createdAt: string;
  public updatedAt: string;

  constructor(data: ImageData) {
    this.id = data.id as number;
    this.path = data.path as string;
    this.altTag = data.alt_tag as string;
    this.createdAt = data.created_at as string;
    this.updatedAt = data.updated_at as string;
  }

  toDTO(): ImageData {
    return {
      id: this.id,
      path: this.path,
      alt_tag: this.altTag,
      created_at: this.createdAt,
      updated_at: this.updatedAt
    };
  }

  static fromDTO(dto: ImageData): Image {
    return new Image(dto);
  }

}
